import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { useNavigate } from "react-router-dom";
const BackBtn = ({ text, link }) => {
  const navigate = useNavigate();
  const handleNavigation = () => {
    navigate(link ? link : "/#Academic");
  };
  return (
    <h5
      onClick={handleNavigation}
      className="section-title pinter-cursor pb-4"
    >
      <FontAwesomeIcon icon={faChevronLeft} className="back-btn" />{" "}
      {text ? text : "Academic Initiatives"}
    </h5>
  );
};

export default BackBtn;
